import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Grid } from '@mui/material';
import React from 'react';
import { ErpTrial } from './ErpTrial';
import { GenericObsessionTypeCard } from './GenericObsessionTypeCard';
import { Homework, isERPHomework, isTaskHomework } from '../utils/Homework';
import { Task } from './Task';

dayjs.extend(utc);
dayjs.extend(timezone);

interface CardTrialProps {
  homework: Homework;
  onTaskChange: (event: any, homeworkId: string) => void;
  onTaskUpdate: (homeworkId: string) => void;
  onTrialChange: (event: any, homeworkId: string, trialId: string) => void;
  onTrialUpdate: (homeworkId: string, trialId: string) => void;
}

export function CardHomework({
  homework,
  onTaskChange,
  onTaskUpdate,
  onTrialChange,
  onTrialUpdate
}: CardTrialProps) {
  const [isHomeworkExpanded, setIsHomeworkExpanded] = React.useState(false);

  const handleCardClick = () => {
    setIsHomeworkExpanded((prevState) => !prevState);
  };

  const cardInfo = [
    {
      title: 'D',
      description: dayjs
        .tz(homework.dueDate, Intl.DateTimeFormat().resolvedOptions().timeZone)
        .format('MM/DD/YYYY'),
      color:
        dayjs
          .tz(
            homework.dueDate,
            Intl.DateTimeFormat().resolvedOptions().timeZone
          )
          .endOf('day')
          .toDate() <
        dayjs
          .tz(new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone)
          .endOf('day')
          .toDate()
          ? 'red'
          : 'black'
    },
    {
      title: 'E',
      description: homework.description
    }
  ];

  if (homework.triggerName) {
    cardInfo.push({
      title: 'T',
      description: homework.triggerName
    });
  }
  if (homework.obsessionName) {
    cardInfo.push({
      title: 'O',
      description: homework.obsessionName
    });
  }
  if (homework.compulsionName) {
    cardInfo.push({
      title: 'C',
      description: homework.compulsionName
    });
  }

  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <GenericObsessionTypeCard
          onClick={handleCardClick}
          obsessionType={homework.obsessionTypeName}
          isSelected={isHomeworkExpanded}
          key={homework.id}
          cardInfo={cardInfo}
        />
      </Grid>
      {isHomeworkExpanded && (
        <Grid item xs={12}>
          {isERPHomework(homework) && (
            <ErpTrial
              onTrialChange={(event: any, trialId: string) =>
                onTrialChange(event, homework.id!, trialId)
              }
              onTrialUpdate={(trialId: string) =>
                onTrialUpdate(homework.id!, trialId)
              }
              trials={homework.trials!}
            />
          )}
        </Grid>
      )}
      {isHomeworkExpanded && (
        <Grid item xs={12}>
          {isTaskHomework(homework) && (
            <Task
              onTaskChange={(event: any) => onTaskChange(event, homework.id!)}
              onTaskUpdate={() => onTaskUpdate(homework.id!)}
              task={homework.task!}
            />
          )}
        </Grid>
      )}
    </>
  );
}
